// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__P_niN","submitButton":"styles_submitButton__IXxXT"};